import create from './create';
import getPrescriptionDiscount from './getPrescriptionDiscount';
import update from './update';
import deletePrescriptionDiscount from './deletePrescriptionDiscount';

export default {
  getPrescriptionDiscount,
  create,
  update,
  deletePrescriptionDiscount,
};
